<h6 class="card-subtitle text-muted">
  <span id="when">Posted: {{quoty.datePosted|datePipe}} days ago.</span>
 </h6>
<div class="container-fluid" id="buttons">
  <button class="btn btn-sm btn-success upvote"  (click)='upvote() ; highestVotes()'  [id]="active" appHighlightQuoteDirective  >{{quoty.likes}} <i class="fa fa-thumbs-up" id="like"></i></button> 
  <button class="btn btn-sm " id="downvote" (click)='downvote() ;  '>{{quoty.dislikes}} <i class="fa fa-thumbs-down" id="dislike"></i></button> 
  <button class="btn btn-sm " id="del" (click)='deleteQuote(true)'><i class="fa fa-trash" id="delete"></i></button> 
</div>
<span class="card-subtitle ">Post by: 
  <span id="name">{{quoty.name}}</span>
  <span id="date">Date Posted: <span id="datecolor">{{quoty.datePosted|date:'short'}}</span></span>
</span>
